import { useEffect, useState } from "react"
import { Spinner } from "asocomponents"
import DocumentoService from "../../../../modules/Documentos/application/DocumentoService.js";
import GrillaAdjuntos from "./GrillaAdjuntos.jsx";
import { useSelector } from "react-redux";
import { setDocumentos } from '../../../redux/facturaSlice.js'

function GrillaAdjuntoFactura({ idFactura }) {

    const [adjuntos, setAdjuntos] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const documentosCargados = useSelector(state => state.rootReducer.datosFactura.documentos)
 
    const obtenerDocumentos = async () => {
        setIsLoading(true)
        const documentosServices = new DocumentoService()
        let documentos = await documentosServices.getDocumentosFactura(idFactura)

        documentos = documentos.sort((a, b) => {
            const prioridad = { FCJ: 1, DCJ: 2 }; // Define la prioridad
            return (prioridad[a.tipoCodigo] || 99) - (prioridad[b.tipoCodigo] || 99);
        })

        setAdjuntos(documentos)
        localStorage.setItem("documentos", JSON.stringify(documentos));
        setIsLoading(false)
    }

    useEffect(() => {
        idFactura ? obtenerDocumentos() : setAdjuntos(documentosCargados)
    }, [documentosCargados])

    if (isLoading) {
        return <Spinner color="red" size="50" />
    } 

    return (
        <GrillaAdjuntos adjuntos={adjuntos} mostrarBotonAcciones={idFactura ? true : false} setDocumentos={setDocumentos}/>
    )
}

export default GrillaAdjuntoFactura